<div class="container" *ngIf="notificacoes && !carregandoNotificacoes">
  <div class="row" *ngIf="exibeDivSemNotificacoes">
    <div class="col-12 mb-4 d-flex justify-content-center">
      <img class="opcao__icone" src="assets/images/icons/sem_notificacoes.png" alt="" />
    </div>
    <div class="col-12 d-flex flex-column justify-content-center align-items-center">
      <h5 class="lovers-font--bold">Sem notificações</h5>
      <h6 class="lovers-font--desc">Fique ligado, a qualquer momento teremos novidades :D</h6>
    </div>
  </div>

  <p class="maisRecentes" *ngIf="!exibeDivSemNotificacoes">Mais recentes</p>

  <div class="row" [ngClass]="{
      'div-card-unread': item.lida === false,
      'div-card': item.lida === true
    }" *ngFor="let item of notificacoes" (click)="redirecionar(item)">
    <div class="col-12">
      <p class="font-titulo">
        <img class="statusMensagem" [src]="
            item.lida == true
              ? 'assets/images/icons/lida.png'
              : 'assets/images/icons/nao_lida.png'
          " />{{ item.titulo }}
      </p>
      <p class="font-data">{{ item.dataInicio | date: "dd/MM/yyyy" }}</p>
      <p class="font-descricao">{{ item.descricao }}</p>
    </div>
  </div>
  <div class="notificacoes__ver__mais" (click)="onClickVerMais()" *ngIf="exibeBotaoVerMais">
    <p class="ver__mais" *ngIf="exibirBotaoCarregarMais()">
      <img class="ver__mais__icone" src="assets/images/icons/mais.png" />
      Ver mais notificações
    </p>
  </div>
</div>

<div class="container" *ngIf="carregandoNotificacoes">
  <ngx-skeleton-loader count="4" [theme]="{
      'border-radius': '10px',
      height: '100px',
      width: '100%',
      display: 'block',
      margin: 'auto',
      'margin-bottom': '24px'
    }"></ngx-skeleton-loader>
</div>
<img class="background__imagem__footer" src="../../../../assets/images/backgrounds/background_gradiente_cima.png">